/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * response object
 * @export
 * @interface PutCharactersCharacterIdCalendarEventIdResponse
 */
export interface PutCharactersCharacterIdCalendarEventIdResponse {
    /**
     * response string
     * @type {string}
     * @memberof PutCharactersCharacterIdCalendarEventIdResponse
     */
    response: PutCharactersCharacterIdCalendarEventIdResponseResponseEnum;
}


/**
 * @export
 */
export const PutCharactersCharacterIdCalendarEventIdResponseResponseEnum = {
    Accepted: 'accepted',
    Declined: 'declined',
    Tentative: 'tentative'
} as const;
export type PutCharactersCharacterIdCalendarEventIdResponseResponseEnum = typeof PutCharactersCharacterIdCalendarEventIdResponseResponseEnum[keyof typeof PutCharactersCharacterIdCalendarEventIdResponseResponseEnum];


/**
 * Check if a given object implements the PutCharactersCharacterIdCalendarEventIdResponse interface.
 */
export function instanceOfPutCharactersCharacterIdCalendarEventIdResponse(value: object): value is PutCharactersCharacterIdCalendarEventIdResponse {
    if (!('response' in value) || value['response'] === undefined) return false;
    return true;
}

export function PutCharactersCharacterIdCalendarEventIdResponseFromJSON(json: any): PutCharactersCharacterIdCalendarEventIdResponse {
    return PutCharactersCharacterIdCalendarEventIdResponseFromJSONTyped(json, false);
}

export function PutCharactersCharacterIdCalendarEventIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutCharactersCharacterIdCalendarEventIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'response': json['response'],
    };
}

export function PutCharactersCharacterIdCalendarEventIdResponseToJSON(json: any): PutCharactersCharacterIdCalendarEventIdResponse {
    return PutCharactersCharacterIdCalendarEventIdResponseToJSONTyped(json, false);
}

export function PutCharactersCharacterIdCalendarEventIdResponseToJSONTyped(value?: PutCharactersCharacterIdCalendarEventIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response': value['response'],
    };
}

